import React, { useState } from "react";
import {
  Button
}
  from "@mui/material";
import { buttonviewmore } from "../../style2";

// const useStyles = makeStyles((theme) => ({
//   buttonviewmore: {
//     fontFamily: "Lato",
//     fontStyle: "normal",
//     fontWeight: "normal",
//     fontSize: 14,
//     color: "#FF767E",
//     textTransform: "unset",
//     "&:hover": {
//       background: "#FFFFFF",
//     },
//   },
// }));



function Header({ handleViewMore }) {
  //const classes = useStyles();
  const [viewMore, setViewMore] = useState(false);

  const handleViewMore1 = () => {
    handleViewMore();
    viewMore ? setViewMore(false) : setViewMore(true);
  };
  return (
    <Button sx={buttonviewmore} onClick={handleViewMore1}>
      {viewMore ? "Show Less" : "Show More"}
    </Button>
  );
}

export default Header;
